export { AdminLayout } from '@/features/admin-geral/components/layout/AdminLayout';
